import { render, staticRenderFns } from "./VpsDetails.vue?vue&type=template&id=62571dda&"
import script from "./VpsDetails.vue?vue&type=script&lang=js&"
export * from "./VpsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports